export let ALL_GATES = [];
export const loadGates = gates => {
  ALL_GATES = gates;
};